import React from 'react';
import PropTypes from 'prop-types';
import FormField from 'mrf/view//FormField';
import { StyledSearchButton } from 'styles/components/SearchField.styles';
import { SearchIcon } from 'styles/components/Icons';
import { generateHtmlId } from 'mrf/utils/StringGenerators';
import Input from './Input';
import { useTranslation } from 'react-i18next';

SearchField.propTypes = {
    handleSearch: PropTypes.func.isRequired, // Callback to perform search.
}

export default function SearchField({
    handleSearch,
    placeholder = 'Search',
    ...props
}) {
    const { t } = useTranslation();
    placeholder = t(placeholder);

    return (
        <FormField
            type='text'
            component={Input}
            autoFocus
            eventMapper={(e) => e.target.value}
            color='paper'
            placeholder={placeholder}
            end={
                <StyledSearchButton
                    onClick={handleSearch}
                    id={generateHtmlId('button', props.id)}
                >
                    <SearchIcon />
                </StyledSearchButton>
            }
            {...props}
        />
    );
}
